//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ServiceRequests from './dashboard/ServiceRequests';
export default {
	components: { ServiceRequests: ServiceRequests },
	props: ['property'],
	mounted: function mounted() {},

	computed: {
		occupancyChartData: function occupancyChartData() {
			var chartData = {};
			this.property.occupancy_datapoints.forEach(function (datapoint) {
				chartData[new Date(datapoint.year + '/' + datapoint.month + '/' + (datapoint.day ? datapoint.day : 1))] = datapoint.rate * 100;
			});
			return chartData;
			// return {'JAN': '97%', 'FEB': '90%', 'MAR': '93%', 'APR': '95%', 'MAY': '95%', 'JUN': '96%', 'JULY': '99%', 'AUG': '100%', 'SEP': '100%', 'OCT': '100%', 'NOV': '100%', 'DEC': '98%'};
		},
		requiredActions: function requiredActions() {

			return this.property.property_notifications;
		},

		pieChartData: function pieChartData() {
			return [['Leased', this.property.leased_units_count], ['Vacant', this.property.unit_count - this.property.leased_units_count]];
		},
		occupancyPercentage: function occupancyPercentage() {
			var occupancyPercentage = this.property.kpis.occupancy_percent * 100;
			return parseFloat(occupancyPercentage).toFixed(2);
		},
		vacantUnits: function vacantUnits() {
			return this.property.unit_count - this.property.leased_units_count;
		},
		availableUnits: function availableUnits() {
			return this.property.available_count;
		},
		percentLeased: function percentLeased() {
			var totalUnit = this.property.unit_count;
			var filteredUnits = this.property.units.filter(function (unit) {
				return unit.status !== 'Vacant - Leased' && unit.status !== 'Vacant - Not Leased';
			}).length;
			return filteredUnits / totalUnit;
		},
		exposure: function exposure() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1;
			var yyyy = today.getFullYear();
			var today = yyyy + '-' + mm + '-' + dd;
			return this.property.units.filter(function (unit) {
				return unit.move_in_date === today || unit.move_out_date === today;
			}).length;
		},
		occupancy: function occupancy() {
			return this.property.units.filter(function (unit) {
				return unit.status !== 'Vacant - Leased' && unit.status !== 'Vacant - Not Leased';
			}).length;
		}
	},
	methods: {
		markRequiredActionRead: function markRequiredActionRead(id) {

			var self = this;

			window.axios.post('/prototype/property-notification', { id: id }).then(function (response) {

				if (response.data) {

					self.openRequiredActionUrl(response.data.url);
				}
			});
		},

		todaysDate: function todaysDate() {
			var currentDate = new Date();
			var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			return currentDateWithFormat;
		},
		openRequiredActionUrl: function openRequiredActionUrl(url) {

			window.open(url, '_blank');
		},
		getRequiredActionStatus: function getRequiredActionStatus() {
			// @TODO: Add this, should return service or person
			return 'person';
		},
		viewNotices: function viewNotices() {
			Event.$emit('view-notices');
		},
		viewVacantUnits: function viewVacantUnits() {
			var units = this.property.units.filter(function (unit) {
				return unit.status == 'Vacant - Not Leased' || unit.status == 'NTV - Available';
			});
			this.openUnitsModal({ units: units, title: 'Available Units' });
		},
		viewPendingServiceRequests: function viewPendingServiceRequests() {
			var _this = this;

			axios.get('/prototype/properties/' + this.property.id + '/serviceRequests').then(function (response) {
				if (response.data) {
					var serviceRequests = [];
					var serviceRequestsClosed = [];
					response.data.forEach(function (element) {
						if (element.assignee) {
							element.assignee.full_name = element.assignee.first_name + ' ' + element.assignee.last_name;
						}
						element.priority_text = '';
						if (element.priority == 1) {
							element.priority_text = 'Low';
						}
						if (element.priority == 2) {
							element.priority_text = 'Medium';
						}
						if (element.priority == 3) {
							element.priority_text = 'High';
						}
						if (element.priority == 4) {
							element.priority_text = 'Urgent';
						}
						if (element.completed_at) {
							serviceRequestsClosed.push(element);
						} else {
							serviceRequests.push(element);
						}
					});
					_this.openServiceRequestsModal({ serviceRequests: serviceRequests, title: 'Open Requests' });
				}
			});
		},
		openUnitsModal: function openUnitsModal(units) {
			this.$refs.propertyUnits.openFullModal(units);
		},
		openServiceRequestsModal: function openServiceRequestsModal(pendingServiceRequests) {
			this.$refs.pendingServiceRequests.openFullModal(pendingServiceRequests);
		},
		manageDeposits: function manageDeposits() {
			Event.$emit('open-property-deposit-modal');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/PropertyDashboard.vue
// module id = 3123
// module chunks = 0 1